import ClassenService from '../ClassenService';

class CategoryService {
  getCategories() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/categories`);
  }

  addCategory(categoryData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/categories`, 'addCategory', categoryData);
  }

  getCategory(categoryId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/categories/${categoryId}`);
  }

  updateCategory(categoryId, categoryData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/categories/${categoryId}`, 'updateCategory', categoryData);
  }

  deleteCategory(categoryId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/categories/${categoryId}`, 'deleteCategory');
  }
}

export default new CategoryService();
